import React from "react"
import { favoriteOffer, unfavoriteOffer } from "../../app/api/favoriteOfferApi"
import { useFavoriteOffers } from "../Features/JobList/FavoriteOffersContext"

/**
 * 求人の「気になる」状態とトグル処理。
 * 初回状態取得の完了時に一度だけ初期値を反映し(クリックとの競合回避)、
 * トグルは楽観更新＋失敗時ロールバック。未ログイン時は /login へ。
 */
export function useFavoriteToggle(offerId: string) {
    const { loaded, favoriteOfferIds } = useFavoriteOffers()
    const [isFavorite, setIsFavorite] = React.useState(false)
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const syncedRef = React.useRef(false)

    React.useEffect(() => {
        if (loaded && !syncedRef.current) {
            syncedRef.current = true
            setIsFavorite(favoriteOfferIds.has(offerId))
        }
    }, [loaded, favoriteOfferIds, offerId])

    const toggle = async () => {
        if (isSubmitting) return
        syncedRef.current = true

        const next = !isFavorite
        setIsFavorite(next)
        setIsSubmitting(true)
        try {
            const res = next
                ? await favoriteOffer(offerId)
                : await unfavoriteOffer(offerId)
            if (res.status === "not_logged_in") {
                window.location.href = "/login"
                return
            }
            if (res.status !== "success") {
                setIsFavorite(!next)
            }
        } catch {
            setIsFavorite(!next)
        } finally {
            setIsSubmitting(false)
        }
    }

    return { isFavorite, isSubmitting, toggle }
}
